import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Router } from '@angular/router';

import { MessageService } from '@services/message.service';
import { HistoricoConciliacaoApiService } from '../../services/historico-conciliacao-api.service';
import { ROTAS } from '@routingModule';

@Component({
  selector: 'app-reconciliar-lancamentos-dialog',
  standalone: false,
  templateUrl: './reconciliar-lancamentos-dialog.component.html',
  styleUrl: './reconciliar-lancamentos-dialog.component.scss'
})
export class ReconciliarLancamentosDialogComponent {

  contaBancoId: number;
  dataInicial: Date;
  dataFinal: Date;

  constructor(
    private messageService: MessageService,
    private router: Router,
    private dialogRef: MatDialogRef<ReconciliarLancamentosDialogComponent>
  ) { }
  
  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // yyyy-MM-dd
  }

  public buscarClick(): void {
    if (!this.dataInicial || !this.dataFinal) {
      this.messageService.showToastWarning('Preencher os campos de data');
      return;
    }
    if (this.dataInicial > this.dataFinal) {
      this.messageService.showToastWarning('Data inicial deve ser anterior a data final');
      return;
    }

    this.router.navigate(
      [ROTAS.reconciliarLancamentos],
      {
        queryParams: {
          contaBancoId: this.contaBancoId,
          dataInicio: this.formatDate(this.dataInicial),
          dataFim: this.formatDate(this.dataFinal)
        }
      }
    );
    this.dialogRef.close(true);
  }
}
